import React from 'react';

import { RenderMachine, StepComponentProps } from 'components/Flow/RenderMachine';

import { nonprofitOnboardingPaymentMachine } from './machine';
import { NonprofitOnboardingPaymentFlowContext } from './context';

export const PaymentStep = (props: StepComponentProps & { id?: string }): JSX.Element | null => (
  <RenderMachine
    machine={nonprofitOnboardingPaymentMachine}
    options={{
      context: {
        standaloneMode: props.standaloneMode,
      },
      actions: {
        handleFinal: () => props.send('NEXT'),
      },
      id: props.id,
    }}
    context={NonprofitOnboardingPaymentFlowContext}
  />
);
